import { Button } from '@/Components/UI/Button/Button';
import { spreadsheetSliceName } from '@/redux/constants';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const MobilePagination = ({
  goToPage,
  pageNumber = 0,
  totalNumber = 0,
  totalNumberOfPages = 0,
}) => {
  const filteredNumberOfRows = useSelector(
    (state) => state[spreadsheetSliceName].filteredNumberOfRows
  );
  const [pageInputValue, setPageInputValue] = useState(1);

  function resizeInput() {
    this.style.width = this.value.length + 3.5 + 'ch';
  }

  const changePage = (_pageNumber) => {
    goToPage(_pageNumber);
    setPageInputValue(_pageNumber + 1);
  };

  useEffect(() => {
    const input = document.querySelector('#currentPage');

    if (input) {
      input.addEventListener('input', resizeInput);
      resizeInput.call(input);
    }

    return () => input?.removeEventListener('input', resizeInput);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (pageInputValue === '') return;

      goToPage(Number(pageInputValue - 1));
    }, 300);
    return () => {
      clearTimeout(timeout);
    };
  }, [pageInputValue, goToPage]);
  useEffect(() => {
    setPageInputValue(Number(pageNumber + 1));
  }, [pageNumber]);

  return (
    <>
      <div className='flex items-center justify-center h-10 py-2 space-x-3'>
        <Button
          color='shadow'
          iconName='arrow-line-left'
          disabled={pageNumber === 0}
          onClick={() => changePage(0)}
        />
        <Button
          type='button'
          disabled={pageNumber === 0}
          color='shadow'
          iconName='arrow-left'
          onClick={() => changePage(pageNumber - 1)}
        />
        <p className='flex items-center justify-center space-x-2'>
          <span>Page</span>
          <input
            type='text'
            className='w-8 text-center border rounded border-ui'
            value={pageInputValue}
            onBlur={() => setPageInputValue(pageNumber + 1)}
            onChange={(event) => {
              const { value } = event.target;
              if (value === '') {
                return setPageInputValue('');
              }
              if (!/^\d+$/.test(value)) return;
              setPageInputValue(value);
            }}
          />
          <span>of</span>
          <span>{totalNumberOfPages}</span>
        </p>
        <Button
          disabled={pageNumber === totalNumberOfPages - 1}
          color='shadow'
          iconName='arrow-right'
          onClick={() => changePage(pageNumber + 1)}
        />

        <Button
          disabled={pageNumber === totalNumberOfPages - 1}
          color='shadow'
          iconName='arrow-line-right'
          onClick={() => changePage(totalNumberOfPages - 1)}
        />
      </div>
      <div className='flex items-center justify-start p-2 space-x-1 text-xs font-extrabold leading-5 tracking-wide uppercase bg-capri-100 text-ui'>
        <span className='mr-1'>Result Set: </span>
        {filteredNumberOfRows < totalNumber && (
          <span>{filteredNumberOfRows?.toLocaleString()} of </span>
        )}
        <span>
          {totalNumber?.toLocaleString()} rows {filteredNumberOfRows < totalNumber && ' found'}
        </span>
      </div>
    </>
  );
};

export default MobilePagination;
